import { useEffect, useState } from 'react';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import PropTypes from 'prop-types';
import { tipoDeArchivo } from './adjuntos';

// Archivos elegidos y listos para enviar: miniatura de las imágenes, tarjeta con nombre para los PDF,
// botón para quitar cada uno y el motivo si alguno se rechazó o el envío falló.
const VistaPreviaAdjuntos = ({ archivos, error, onQuitar, enviando, procesando }) => {
  // URLs temporales para las miniaturas; se liberan al cambiar la selección o al desmontar
  const [miniaturas, setMiniaturas] = useState([]);
  useEffect(() => {
    const urls = archivos.map((f) => (tipoDeArchivo(f) === 'imagen' ? URL.createObjectURL(f) : null));
    setMiniaturas(urls);
    return () => urls.forEach((u) => { if (u) URL.revokeObjectURL(u); });
  }, [archivos]);

  if (!archivos.length && !error && !procesando) return null;

  return (
    <Box sx={{ mb: 1 }}>
      {archivos.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, pt: 0.75, opacity: enviando ? 0.6 : 1 }}>
          {archivos.map((f, i) => (
            <Box
              key={`${f.name}-${f.size}-${i}`}
              sx={{ position: 'relative', borderRadius: 2, border: 1, borderColor: 'divider', bgcolor: 'white', overflow: 'visible' }}
            >
              {miniaturas[i] ? (
                <Box
                  component="img" src={miniaturas[i]} alt={f.name}
                  sx={{ display: 'block', width: 56, height: 56, objectFit: 'cover', borderRadius: 2 }}
                />
              ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, height: 56, px: 1, maxWidth: 170 }}>
                  <PictureAsPdfOutlinedIcon sx={{ color: 'error.oscuro', flexShrink: 0 }} />
                  <Typography variant="caption" noWrap sx={{ color: 'primary.main', fontWeight: 600 }}>{f.name}</Typography>
                </Box>
              )}
              <IconButton
                size="small"
                aria-label={`Quitar ${f.name}`}
                onClick={() => onQuitar(i)}
                disabled={enviando}
                sx={{
                  position: 'absolute', top: -8, right: -8, width: 20, height: 20,
                  bgcolor: 'white', border: 1, borderColor: 'divider', color: 'text.secondary',
                  '&:hover': { bgcolor: 'sutil' },
                }}
              >
                <CloseIcon sx={{ fontSize: 14 }} />
              </IconButton>
            </Box>
          ))}
        </Box>
      )}
      {procesando && (
        <Box role="status" sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.5 }}>
          <CircularProgress size={12} />
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>Optimizando fotos…</Typography>
        </Box>
      )}
      {error && (
        <Typography role="alert" variant="caption" color="error.oscuro" sx={{ display: 'block', mt: 0.5 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

VistaPreviaAdjuntos.propTypes = {
  archivos: PropTypes.array.isRequired,
  error: PropTypes.string,
  onQuitar: PropTypes.func.isRequired,
  enviando: PropTypes.bool,
  procesando: PropTypes.bool,
};

export default VistaPreviaAdjuntos;
